import {
  call,
  getContext,
  put,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";

import {
  getFAQItemByCategoryActionTypes,
  getListFAQCategoryActionTypes,
  getPortionFAQItemByCategoryActionTypes,
  getPortionListFAQCategoryActionTypes,
} from "./actionTypes";
import { CONTEXT } from "@const/redux";
import {
  normalizeFAQCategoriesArray,
  normalizeFAQCategoryItemsArray,
} from "@helpers/faq";
import {
  getFAQCategoryItemsFailure,
  getFAQCategoryItemsSuccess,
  getListFAQCategoriesFailure,
  getListFAQCategoriesSuccess,
  getPortionFAQCategoryItemsFailure,
  getPortionFAQCategoryItemsSuccess,
  getPortionListFAQCategoryFailure,
  getPortionListFAQCategorySuccess,
} from "./actions";

const getListFAQCategoriesAsync = ({ FAQService, params }) => {
  if (!FAQService) {
    console.log("Required services does not exist");
    return null;
  }

  return FAQService.getListFAQCategories(params);
};

function* getListFAQCategories({ payload }) {
  try {
    const { FAQService } = yield getContext(CONTEXT.SERVICES);

    const { data, pagination } = yield call(getListFAQCategoriesAsync, {
      FAQService,
      params: payload,
    });

    const { entities, result: allCategories } =
      normalizeFAQCategoriesArray(data);
    const { categories: categoriesById } = entities;

    const { totalCount, nextOffset } = pagination;

    yield put(
      getListFAQCategoriesSuccess({
        totalCount,
        nextOffset,
        allCategories,
        categoriesById,
      }),
    );
  } catch ({ error }) {
    yield put(getListFAQCategoriesFailure(error));
  }
}

function* getListFAQCategoriesPortion({ payload }) {
  try {
    const { FAQService } = yield getContext(CONTEXT.SERVICES);

    const { data, pagination } = yield call(getListFAQCategoriesAsync, {
      FAQService,
      params: payload,
    });

    const { entities, result: allCategories } =
      normalizeFAQCategoriesArray(data);
    const { categories: categoriesById } = entities;

    const { totalCount, nextOffset } = pagination;

    yield put(
      getPortionListFAQCategorySuccess({
        totalCount,
        allCategories,
        categoriesById,
        nextOffset,
      }),
    );
  } catch ({ error }) {
    yield put(getPortionListFAQCategoryFailure(error));
  }
}

const getFAQCategoryItemsAsync = ({ FAQService, id, params }) => {
  if (!FAQService) {
    console.log("Required services does not exist");
    return null;
  }

  return FAQService.getFAQCategoryItems(id, params);
};

function* getFAQCategoryItems({ payload }) {
  try {
    const { id, ...params } = payload;
    const { FAQService } = yield getContext(CONTEXT.SERVICES);

    const { data, pagination } = yield call(getFAQCategoryItemsAsync, {
      FAQService,
      id,
      params,
    });

    const { entities, result: allItems } = normalizeFAQCategoryItemsArray(data);
    const { items: itemsById } = entities;

    const { totalCount, nextOffset } = pagination;

    yield put(
      getFAQCategoryItemsSuccess({
        allItems,
        itemsById,
        itemsNextOffset: nextOffset,
        itemsTotalCount: totalCount,
      }),
    );
  } catch ({ error }) {
    yield put(getFAQCategoryItemsFailure(error));
  }
}

function* getPortionFAQCategoryItems({ payload }) {
  try {
    const { id, ...params } = payload;

    const { FAQService } = yield getContext(CONTEXT.SERVICES);

    const { data, pagination } = yield call(getFAQCategoryItemsAsync, {
      FAQService,
      id,
      params,
    });

    const { entities, result: allItems } = normalizeFAQCategoryItemsArray(data);
    const { items: itemsById } = entities;

    const { totalCount, nextOffset } = pagination;

    yield put(
      getPortionFAQCategoryItemsSuccess({
        allItems,
        itemsById,
        itemsNextOffset: nextOffset,
        itemsTotalCount: totalCount,
      }),
    );
  } catch ({ error }) {
    yield put(getPortionFAQCategoryItemsFailure(error));
  }
}

export function* watchGetListFAQCategories() {
  yield takeEvery(getListFAQCategoryActionTypes.request, getListFAQCategories);
}

export function* watchGetListFAQCategoriesPortion() {
  yield takeLatest(
    getPortionListFAQCategoryActionTypes.request,
    getListFAQCategoriesPortion,
  );
}

export function* watchGetFAQCategoryItems() {
  yield takeEvery(getFAQItemByCategoryActionTypes.request, getFAQCategoryItems);
}

export function* watchGetFAQCategoryItemsPortion() {
  yield takeEvery(
    getPortionFAQItemByCategoryActionTypes.request,
    getPortionFAQCategoryItems,
  );
}
